import { render, staticRenderFns } from "./c-flying-frame@.vue?vue&type=template&id=6431abea&"
import script from "./c-flying-frame@.vue?vue&type=script&lang=ts&"
export * from "./c-flying-frame@.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports